import React from 'react';
import { Euro, FileText, Clock, TrendingUp } from 'lucide-react';
import KPICard from '../shared/KPICard';

const KPISection = ({
  currentMonthRevenue = 0,
  currentMonthInvoiceCount = 0,
  totalOutstanding = 0,
  averageInvoiceValue = 0,
  loading = false,
  periodLabel = "Deze maand"
}) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3 lg:gap-4 mb-3 lg:mb-6">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-white rounded-lg shadow p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded mb-2"></div>
            <div className="h-8 bg-gray-200 rounded mb-2"></div>
            <div className="h-3 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-3 lg:gap-4 mb-3 lg:mb-6">
            <KPICard
              title="Omzet"
              value={formatCurrency(currentMonthRevenue)}
              subtitle={`${periodLabel} (excl.)`}
              icon={Euro}
              className="theme-blue"
            />
            <KPICard
              title="Facturen"
              value={currentMonthInvoiceCount.toString()}
              subtitle={periodLabel}
              icon={FileText}
              className="theme-blue"
            />
            <KPICard
              title="Gem. Factuur"
              value={formatCurrency(averageInvoiceValue)}
              subtitle="Per factuur (excl.)"
              icon={TrendingUp}
              className="theme-blue"
            />
            <KPICard
              title="Openstaand"
              value={formatCurrency(totalOutstanding)}
              subtitle="Totaal (incl.)"
              icon={Clock}
              className="theme-blue"
            />
    </div>
  );
};

export default KPISection;
